var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCookies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "transparent",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 13.6283L12.795 13.3333M8.33333 14.4616L8.62833 14.1666M6.66666 6.96164L6.96083 6.66664M5.83333 11.1283L6.1275 10.8333M10 10.295L10.295 9.99997M10.0025 17.5C11.9425 17.4999 13.807 16.7484 15.2047 15.4031C16.6025 14.0579 17.4248 12.2235 17.4992 10.285C17.5042 10.1575 17.3658 10.0766 17.2508 10.1341C15.1875 11.1733 13.9125 10.07 14.12 8.58914C14.1235 8.56053 14.1206 8.53149 14.1113 8.50419C14.1021 8.47688 14.0868 8.45201 14.0666 8.43143C14.0464 8.41084 14.0219 8.39508 13.9948 8.3853C13.9676 8.37553 13.9387 8.372 13.91 8.37497C12.1008 8.62747 11.3383 7.52997 11.6233 6.03831C11.6276 6.0129 11.6265 5.98689 11.6203 5.96191C11.614 5.93692 11.6026 5.9135 11.5869 5.89309C11.5712 5.87268 11.5515 5.85573 11.5289 5.8433C11.5064 5.83086 11.4815 5.8232 11.4558 5.82081C9.75333 5.66914 9.6125 3.70414 9.905 2.74581C9.94083 2.62747 9.85583 2.49581 9.7325 2.49997C7.76807 2.57172 5.91027 3.41159 4.55867 4.83894C3.20708 6.26628 2.46967 8.16708 2.50505 10.1325C2.54042 12.0979 3.34576 13.9709 4.74785 15.3487C6.14994 16.7265 8.03676 17.499 10.0025 17.5Z",
    stroke: "#62748E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCookies);
export default __webpack_public_path__ + "static/media/cookies.0984a63ae824419f4810c6e93c3e97bc.svg";
export { ForwardRef as ReactComponent };